import { useContext, useEffect } from 'react';

import { WebsocketConnectionContext } from '../contexts/websocketConnection';

const useWebsocket = <T>(type: string, cb: (message: T) => void, dependencies: any[] = []) => {
    const websocket = useContext(WebsocketConnectionContext);

    // Add a listener on the websocket object when the hook is mounted.
    // Remove the listener when the hook is unmounted.
    useEffect(() => {
        if (websocket === null) {
            return;
        }

        const listener = (event: MessageEvent) => {
            const message = JSON.parse(event.data);
            if (message.type === type) {
                cb(message.data);
            }
        };

        websocket.addEventListener('message', listener);

        return () => websocket.removeEventListener('message', listener);
    }, [websocket, ...dependencies]);
};

export default useWebsocket;
